import { StickyResolver } from './classes/StickyResolver';
import { Remember } from './classes/Remember';
import { Variant } from './classes/Variant';

document.addEventListener('DOMContentLoaded', function() {
    new StickyResolver(document.querySelector('.sticky-product-img'));
    new Remember(document.querySelector('input[name=globalsearch]'), 'globalsearch');
    new Variant(document.querySelectorAll('.variant-info'));
});

['order-matrix-loaded', 'order-matrix-modal-content-loaded'].forEach(function(e) {
    document.addEventListener(e, function() {
        new Variant(document.querySelectorAll('.variant-info'));
    });
});
